module.exports = __webpack_public_path__ + "media/clocktick.f039f164.mp3";